import React, { useState } from "react";

const Patnership = () => {
  
    const [openSection, setOpenSection] = useState(null);
  
    const toggleSection = (section) => {
      setOpenSection(openSection === section ? null : section);
    };
  const handleAppointmentClick = () => {
    window.open(
      "http://topmate.io/sanjay_nathani/?utm_source=topmate&utm_medium=popup&utm_campaign=Page_Ready",
      "_blank"
    );
  };

  return (
    <div className="p-8 bg-gray-100">
      {/* Title Section */}
      <h1 className="text-3xl font-bold text-center mb-6">
        Patnership Registration
      </h1>
      <p className="text-gray-700 mb-6 text-center text-justify">
        In India, Partnership Act, 1932 lays down the definition and regulations
        for Partnership Firm and the provisions of this act (under section 4)
        defines partnership as – “An agreement between persons who have agreed
        to share profits of the carried on by all or any one of them acting for
        all.”
      </p>
      <p className="text-gray-700 mb-6 text-center text-justify">
        When two or more persons have the same business idea and they wish to
        work together to turn that idea into reality, they get into partnership
        by incorporating a partnership firm. So, Partnership is combined
        ownership of a business between two or more people. Like a sole
        proprietorship, there is no legal separation between the business and
        the individual partners. The partnership is formed by an agreement
        among the partners in which all the terms of partnership are discussed.
      </p>
      <p className="text-gray-700 mb-6 text-center text-justify">
        The Registration of a partnership firm is not compulsory, though it is
        usually done as registration brings many advantages to the firm. It is
        optional for partners to set the firm registered & there are no
        penalties for non-registration but it is always advisable to get the
        registration done as it bestows a legal existence and avoids conflicts
        in future. Partnership Registration is done on their respective state
        websites.
      </p>
      <p className="text-gray-700 mb-6 text-center text-justify">LLP is one of the easiest types of businesses to incorporate & manage and it integrates the advantages of a Partnership Firm and a Company.</p>

     

  <div className="space-y-4 mx-10 lg:mx-40">
        {/* Section 1 */}
        <div
          className={`border rounded-lg ${
            openSection === 1 ? "bg-blue-100" : "bg-[#005A8C]"
          }`}
        >
          <button
            onClick={() => toggleSection(1)}
            className="w-full text-left px-4 py-3 text-white font-bold flex justify-between items-center"
          >
            1. Documents Required
            <span>{openSection === 1 ? "-" : "+"}</span>
          </button>
          {openSection === 1 && (
            <ul className="list-disc pl-5 mt-2 bg-white text-gray-700">
            <li>Application for registration of partnership (Form 1)</li>
            <li>Specimen of Affidavit</li>
            <li>Certified original copy of Partnership Deed</li>
            <li>Proof of principal place of business (ownership documents or rental/lease agreement).</li>
            <li>If the registrar is satisfied with the documents, he will register the firm in the Register of Firms and issue Certificate of Registration.</li>
          </ul>
          )}
        </div>
        </div>

      {/* Get in Touch Section */}
      <div className="bg-gray-50 p-4 rounded-lg shadow-md mt-6">
          <h3 className="text-lg md:text-xl font-semibold mb-2">Get in touch</h3>
          <p className="text-gray-700 mb-4 text-sm md:text-base">
            If you have any queries or questions, please reach out to us by clicking on the contact button and filling out the form.
          </p>
          <div className="flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4">
            <button
              onClick={handleAppointmentClick}
              className="bg-orange-500 text-white py-2 px-4 rounded-md hover:bg-orange-600 w-full sm:w-auto"
            >
              Make Appointment
            </button>
            <button className="bg-[#005A8C] text-white py-2 px-4 rounded-md  w-full sm:w-auto">
              Contact Us
            </button>
          </div>
          </div>
    </div>
  );
};

export default Patnership;
